<template>
  <Modal title="Enviar Mensaje Inxapp" @close="emitClose">
    <form @submit.prevent="sendMessage" class="p-5 grid grid-cols-12">

      <div class="col-span-12">
        <label>Titulo:</label>
        <input class="input w-full border mt-2" v-model="title" required />
      </div>
      <div class="col-span-12 mt-2">
        <label>Mensaje:</label>
        <textarea class="input w-full border mt-2" v-model="message" required></textarea>
      </div>

      <div class="col-span-12 px-5 py-3 text-right border-t border-gray-200">
        <button type="button" data-dismiss="modal" class="button border text-gray-700 mr-1" @click="emitClose">
          Cancelar
        </button>
        <button type="submit" class="button bg-theme-1 text-white" id="edit">
          Enviar
        </button>
      </div>
    </form>
  </Modal>
</template>

<script>
  import axios from '@/services/axios'
  import Modal from '@/components/assets/Modal/Modal'

  export default {
    data() {
      return {
        title: "",
        message: "",
      }
    },
    created() {

    },
    methods: {
      async sendMessage() {
        this.errors = []
        this.loading = true

        try {

          var data = { 'title' : this.title , 'message': this.message }
          console.log(data)
          const { data: { total }} = await axios.post('/message', data)

          window.$toast.info(total+' mensaje(s) enviado(s) correctamente')
          window.location.reload()
        } catch (error) {
          console.log({error})
          this.errors = error.response.data.errors
          console.log(this.errors)
        } finally {
          this.loading = false
        }
      },
      emitClose() {
        this.$emit('close')
      }
    },
    components: {
      Modal
    }
  }
</script>



// WEBPACK FOOTER //
// ModalMessage.vue?3eb459ce